export const CATEGORY_ADD = "CATEGORY_ADD";
export const CATEGORY_LIST = "CATEGORY_LIST";
export const CATEGORY_UPDATE = "CATEGORY_UPDATE";
export const CATEGORY_REQUEST = "CATEGORY_REQUEST"
export const CLEAR_ERRORS = "CLEAR_ERRORS";